const FOOTER_HEIGHT = 56;

export { FOOTER_HEIGHT };
